module.exports = __webpack_public_path__ + "assets/media/conley-1.8b590c43.png";